import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { BrokenLinkReport } from './broken-link-report';

@Injectable()
export class ReportBrokenLinkService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  reportBrokenLink(
    brokenLinkReport: BrokenLinkReport,
  ): Observable<BrokenLinkReport> {
    const path = this.tarlV3Jsonapi.path('/broken_link_reports', {});
    return this.tarlV3Jsonapi.postResource(path, brokenLinkReport);
  }
}
